<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import { required } from "vuelidate/lib/validators";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: { Layout },
  data() {
    return {
      search: {
        loading: false,
        order: null,
      },

      user: {
        name: null,
        email: null,
        cellphone: null,
        avatar: null,
      },

      order: {
        modal: false,
        loading: false,

        id: null,
        date: null,

        item: null,
        total: 0,

        payment: {
          name: 'Saldo em Conta',
          status: 'pending',
          total: null,
          address: null,
          qrcode: null,
          expiration: null,
        }
      },

      pay: {
        type: 'partial',
        options: [
          { text: 'Parcial – 50%', value: 'partial' },
          { text: 'Total – 100%', value: 'total' },
        ],
      }
    };
  },
  validations: {
    order: { required },
  },
  methods: {
    searchOrder() {
      this.$v.$touch();

      if (this.search.order) {
        this.search.loading = true

        api
          .post('wallet/pay/search', {
            order: this.search.order,
          })
          .then(response => {
            if (response.data.status == 'success') {
              this.search.order = ''

              this.$v.$reset()
              this.order.id = response.data.order.id
              this.order.date = response.data.order.date
              this.order.item = response.data.order.item
              this.order.total = response.data.order.total

              this.user.name = response.data.order.user.name
              this.user.email = response.data.order.user.email
              this.user.cellphone = response.data.order.user.cellphone
              this.user.avatar = response.data.order.user.avatar

              this.order.modal = true
            } else {
              this.$toast.error(this.t(response.data.message))
            }

            this.search.loading = false
          })
          .catch(error => {
            if (error) {
              this.search.loading = false
            }
          })
      }
    },
    payOrder(id) {
      this.order.loading = true

      api
        .post('wallet/pay', {
          order: id,
          type: this.pay.type,
        })
        .then((response) => {
          if (response.data.status == 'success') {
            this.$toast.success(response.data.message)
            this.order.modal = false

            this.$router.replace('/wallet/extract');
          } else {
            this.$toast.error(response.data.message)
          }

          this.order.loading = false
        })
        .catch(error => {
          if (error) {
            this.order.loading = false
          }
        })
    },
    getOrder() {
      if (this.$route.params.id) {
        this.search.order = this.$route.params.id
        this.searchOrder()
        this.$router.replace('/wallet/pay');
      }
    }
  },
  mounted() {
    this.getOrder()
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/wallet/extract">Financeiro</router-link></li>
      <li class="breadcrumb-item d-none d-sm-block">Pagar</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>Pagar</h3>
        <p></p>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-xl-7">
        <div class="card">
          <div class="card-body p-4">
            <b-form class="p-3" @submit.prevent="searchOrder">
              <b-form-group id="order" label="Digite o número do pedido" label-for="order">
                <b-form-input id="order" v-model="search.order" type="text" :class="{ 'is-invalid': $v.order.$error }"></b-form-input>
                <div v-if="$v.order.$error" class="invalid-feedback">
                  <span v-if="!$v.order.required">O número do pedido é obrigatório.</span>
                </div>
              </b-form-group>
              <div class="mt-4">
                <b-button :disabled="search.loading == true || this.search.order === ''" type="submit" variant="default" class="btn-lg btn-block">
                  Pagar
                  <b-spinner v-if="search.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
                </b-button>
              </div>
            </b-form>
          </div>
        </div>

        <b-modal v-model="order.modal" hide-footer centered header-class="border-0" body-class="pt-0 px-3">
          <div class="px-3">
            <div class="text-center mb-3">
              <div class="text-dark text-center font-weight-bold">
                <strong class="text-uppercase font-weight-normal">Pedido</strong> - {{ order.id }}
              </div>
            </div>
            <div class="d-flex justify-content-between mb-2">
              <p class="m-0 text-uppercase">Data:</p>
              <p class="m-0">{{ order.date }}</p>
            </div>
            <hr class="mt-0" style="border:1px dashed ;">
            <div v-if="user.name" class="d-flex align-items-center">
              <img v-if="user.avatar" class="rounded-circle header-profile-user m-2 mx-2" width="30px" height="30px" :src="user.avatar" alt="" />
              <img v-else class="rounded-circle header-profile-user" width="30px" height="30px" :src="'https://ui-avatars.com/api/?background=332EB3&color=fff&name=' + user.name" alt="" />
              <figcaption class="font-weight-bold">
                <strong class="ml-2">{{ user.name }}</strong>
              </figcaption>
            </div>
            <hr class="my-2">
            <div class="d-flex justify-content-between">
              <p class="m-0">Item</p>
              <p class="m-0 text-right">{{ order.item }}</p>
            </div>
            <hr class="my-2">
            <div class="d-flex justify-content-between">
              <p class="m-0">Total</p>
              <p class="m-0"><b class="font-weight-normal">{{ order.total | currency }}</b></p>
            </div>
            <b-form class="my-3 text-center" @submit.prevent="payOrder(order.id)">
              <b-form-radio-group v-model="pay.type" class="mb-3">
                <b-form-radio value="partial" class="pay-type" :class="{ 'pay-type-selected': pay.type == 'partial' }">
                  <div>Parcial – 50%</div>
                </b-form-radio>
                <b-form-radio value="total" class="pay-type" :class="{ 'pay-type-selected': pay.type == 'total' }">
                  <div>Total – 100%</div>
                </b-form-radio>
              </b-form-radio-group>
              <hr class="my-2">
              <div class="d-flex justify-content-between mb-4">
                <p class="m-0">Valor à pagar</p>
                <p class="m-0"><b class="font-weight-normal">{{ (order.total * (pay.type == 'partial' ? 0.5 : 1)) | currency }}</b></p>
              </div>
              <b-button class="w-100 btn-lg" v-b-modal.modal-1 :disabled="order.loading == true" type="submit" variant="success">
                Confirmar pagamento
                <b-spinner v-if="order.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
              </b-button>
            </b-form>
          </div>
        </b-modal>
      </div>
    </div>
  </Layout>
</template>

<style>
.pay-type {
  border-radius: 5px;
  background-color: #CCCBEC;
  border: 1px solid #CCCBEC;
  cursor: pointer;
}
.pay-type-selected {
  background-color: #332EB3;
  border: 1px solid #332EB3;
  color: #fff;
}
.pay-type label {
  cursor: pointer;
  padding: 10px 15px 10px 10px;
}
.pay-type label::before,
.pay-type label::after {
  top: 13px;
  left: -14px;
}
</style>
